import { lazy } from 'react';
import SideBar from '../../components/navigation/SideBar';
import Apidoc from './apidoc';
import DashboardProvider from '../../context/DashboardContext';
import Home from './Home';
import SectionHelper from '../../components/helpDocs/SectionHelper';
import SuspenseSkeleton from '../../components/containers/SuspenseSkeleton';
import UserProfile from './perfil/UserProfile';
import RouterBase from '../../components/navigation/RouterBase';
import { URLAPP } from '../../config';
import StartLinkCard from '../../components/navigation/StartLinkCard';
import ResourcesRouter from './recursos';
import Ambientaciones from './ambientaciones';
import { AnimatePresence } from 'framer-motion';
import TicketsOperation from './tickets';

const Workspace = lazy(() => import('./workspace'));
const Blog = lazy(() => import('./blog'));
const Sdk = lazy(() => import('./mobile'));
const Roles = lazy(() => import('./accesos'));

export default function Dashboard() {
    return (
        <DashboardProvider>
            <AnimatePresence>
                <SideBar />
                <SectionHelper>
                    <RouterBase
                        home={<Home />}
                        items={[
                            { component: <UserProfile />, fullPath: URLAPP.profile },
                            { component: <SuspenseSkeleton itemLazy={<Workspace />} />, fullPath: URLAPP.workspace, nestedRouter: true },
                            { component: <SuspenseSkeleton itemLazy={<Sdk />} />, fullPath: URLAPP.mobile, nestedRouter: true },
                            { component: <SuspenseSkeleton itemLazy={<Blog />} />, fullPath: URLAPP.blog, nestedRouter: true },
                            { component: <SuspenseSkeleton itemLazy={<Roles />} />, fullPath: URLAPP.accessRol, nestedRouter: true },
                            { component: <Apidoc />, fullPath: URLAPP.apidoc, nestedRouter: true },
                            { component: <Ambientaciones />, fullPath: URLAPP.sarenv, nestedRouter: true },
                            { component: <ResourcesRouter />, fullPath: URLAPP.linkedResources, nestedRouter: true },
                            { component: <TicketsOperation />, fullPath: URLAPP.tickets, nestedRouter: true },
                            { component: <StartLinkCard />, fullPath: URLAPP.start }
                        ]}
                    />
                </SectionHelper>
            </AnimatePresence>
        </DashboardProvider>
    );
}